const BASE_URL = 'https://jdzlvzjz97.execute-api.us-east-2.amazonaws.com/v1/CRA';

const handleResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || `API request failed with status ${response.status}`);
  }
  // Parse the nested body string if present
  if (data.body && typeof data.body === 'string') {
    try {
      return JSON.parse(data.body);
    } catch (error) {
      throw new Error(`Failed to parse response body: ${error.message}`);
    }
  }
  return data;
};

export const apiService = {
  signup: async ({ email, name, password, environment }) => {
    try {
      const response = await fetch(`${BASE_URL}/signUp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, name, password, environment }),
      });
      return await handleResponse(response);
    } catch (error) {
      throw new Error(`Signup failed: ${error.message}`);
    }
  },

  login: async ({ email, password }) => {
    try {
      const response = await fetch(`${BASE_URL}/singIn`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      return await handleResponse(response);
    } catch (error) {
      throw new Error(`Login failed: ${error.message}`);
    }
  },

  analyzeDocument: async ({ email, name, documentURL }) => {
    try {
      const response = await fetch(`https://8w34xqc9x1.execute-api.ap-south-1.amazonaws.com/v1/analyze`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, name, documentURL }),
      });
      return await handleResponse(response);
    } catch (error) {
      throw new Error(`Document analysis failed: ${error.message}`);
    }
  },

  getRecentAnalyses: async (email) => {
    try {
      const response = await fetch(`${BASE_URL}/get_recent_analysis`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      return await handleResponse(response);
    } catch (error) {
      throw new Error(`Fetching recent analyses failed: ${error.message}`);
    }
  },

  getCredits: async (email) => {
    try {
      if (!email) {
        throw new Error('Email is required to fetch credits');
      }
      const response = await fetch(`${BASE_URL}/get_credits`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: JSON.stringify({ email }),
      });
      return await handleResponse(response);
    } catch (error) {
      throw new Error(`Fetching credits failed: ${error.message}`);
    }
  },

  createPaymentIntent: async ({ email, amount }) => {
    try {
      if (!email || !amount || amount <= 0) {
        throw new Error('Invalid email or amount');
      }
      const response = await fetch(`${BASE_URL}/payment/create_payment_intent`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: JSON.stringify({ email, amount }),
      });
      const data = await handleResponse(response);
      if (!data.clientSecret || typeof data.clientSecret !== 'string') {
        throw new Error('Invalid or missing clientSecret in response');
      }
      return data; // Returns { clientSecret: "pi_..." }
    } catch (error) {
      throw new Error(`Creating payment intent failed: ${error.message}`);
    }
  },
};